"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.parseResponse = exports.buildFetchOpts = exports.buildFetchUrl = exports.HttpError = void 0;

var _util = require("./util");

var _url = require("./url");

var _defaults = require("../defaults");

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

var HttpError = /*#__PURE__*/function (_Error) {
  _inherits(HttpError, _Error);

  function HttpError() {
    var _this;

    var statusCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 500;

    var _ref = arguments.length > 1 ? arguments[1] : undefined,
        body = _ref.body,
        _ref$message = _ref.message,
        message = _ref$message === void 0 ? 'HttpError' : _ref$message;

    _classCallCheck(this, HttpError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HttpError).call(this, message));
    _this.name = _this.constructor.name;
    _this.message = message;

    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(_assertThisInitialized(_this), _this.constructor);
    } else {
      _this.stack = new Error(message).stack;
    } // Http


    _this.statusCode = statusCode;
    _this.status = statusCode;
    _this.body = body;
    return _this;
  }

  return HttpError;
}(_wrapNativeSuper(Error));

exports.HttpError = HttpError;

var buildFetchUrl = function buildFetchUrl(context, _ref2) {
  var url = _ref2.url,
      urlParams = _ref2.urlParams,
      _ref2$stripTrailingSl = _ref2.stripTrailingSlashes,
      stripTrailingSlashes = _ref2$stripTrailingSl === void 0 ? true : _ref2$stripTrailingSl;

  var _splitUrlByProtocolAn = (0, _url.splitUrlByProtocolAndDomain)(url),
      _splitUrlByProtocolAn2 = _slicedToArray(_splitUrlByProtocolAn, 2),
      _splitUrlByProtocolAn3 = _splitUrlByProtocolAn2[0],
      protocolAndDomain = _splitUrlByProtocolAn3 === void 0 ? '' : _splitUrlByProtocolAn3,
      remainderUrl = _splitUrlByProtocolAn2[1]; // Replace urlParams with values from context


  var builtUrl = Object.keys(urlParams).reduce(function (wipUrl, urlParam) {
    var urlParamInfo = urlParams[urlParam];
    var contextAsObject = !(0, _util.isObject)(context) ? _defineProperty({}, _defaults.defaultIdKeys.singular, context) : context;
    var value = contextAsObject[urlParam] || ''; // self.defaults[urlParam];

    if (value) {
      var encodedValue = urlParamInfo.isQueryParamValue ? (0, _url.encodeUriQuery)(value, true) : (0, _url.encodeUriSegment)(value);
      return (0, _url.replaceUrlParamFromUrl)(wipUrl, urlParam, encodedValue);
    }

    return (0, _url.replaceUrlParamFromUrl)(wipUrl, urlParam);
  }, remainderUrl); // Strip trailing slashes and set the url (unless this behavior is specifically disabled)

  if (stripTrailingSlashes) {
    builtUrl = builtUrl.replace(/\/+$/, '') || '/';
  }

  return protocolAndDomain + builtUrl;
};

exports.buildFetchUrl = buildFetchUrl;

var buildFetchOpts = function buildFetchOpts(context, _ref4) {
  var method = _ref4.method,
      headers = _ref4.headers,
      credentials = _ref4.credentials,
      query = _ref4.query,
      body = _ref4.body;
  var opts = {
    headers: _defaults.defaultHeaders
  };

  if (method) {
    opts.method = method;
  }

  if (headers) {
    opts.headers = _objectSpread({}, opts.headers, headers);
  }

  if (credentials) {
    opts.credentials = credentials;
  }

  if (query) {
    opts.query = query;
  }

  var hasBody = /^(POST|PUT|PATCH|DELETE)$/i.test(opts.method);

  if (body) {
    opts.body = (0, _util.isString)(body) ? body : JSON.stringify(body);
  } else if (hasBody && context) {
    var contextAsObject = !(0, _util.isObject)(context) ? _defineProperty({}, _defaults.defaultIdKeys.singular, context) : context;
    opts.body = JSON.stringify(contextAsObject);
  }

  return opts;
};

exports.buildFetchOpts = buildFetchOpts;

var parseResponse = function parseResponse(res) {
  var contentType = res.headers.get('Content-Type'); // @NOTE parses 'application/problem+json; charset=utf-8' for example
  // see https://tools.ietf.org/html/rfc6839

  var isJson = contentType && ((0, _util.startsWith)(contentType, 'application/json') || (0, _util.endsWith)(contentType.split(';')[0], '+json'));
  return res[isJson ? 'json' : 'text']();
};

exports.parseResponse = parseResponse;

var fetch = function fetch(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}; // Support options.query

  var builtUrl = Object.keys(options.query || []).reduce(function (wipUrl, queryParam) {
    var queryParamValue = (0, _util.isString)(options.query[queryParam]) ? options.query[queryParam] : JSON.stringify(options.query[queryParam]);
    return (0, _url.replaceQueryStringParamFromUrl)(wipUrl, queryParam, queryParamValue);
  }, url);
  return (options.Promise || _defaults.defaultGlobals.Promise).resolve((_defaults.defaultGlobals.fetch || fetch)(builtUrl, options)).then(function (res) {
    if (!res.ok) {
      return parseResponse(res).then(function (body) {
        throw new HttpError(res.status, {
          body: body
        });
      });
    }

    return res;
  });
};

var _default = fetch;
exports.default = _default;